"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../constants/index.js");
var _validateUserAccountID = _interopRequireDefault(require("./validateUserAccountID"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var UUID = _index.localStorageKeys.UUID;
var getUserAccountID = function getUserAccountID() {
  var localStorageUUID = localStorage.getItem(UUID);
  if ((0, _validateUserAccountID["default"])(localStorageUUID)) return localStorageUUID;
};
var _default = exports["default"] = getUserAccountID;